import { appConfig } from '../../utils/appConfig';
import ProductCard, { ProductCardProps } from './_ProductCard';
import ProductCardMeater from './_ProductCardMeater';
import { classNames } from '@repo/ui/src/utils/classNames';

interface ProductListProps {
  title?: string;
  products: Array<ProductCardProps>;
  primaryHeader?: string;
  secondaryHeader?: string;
}

const ProductList = ({ products, title, primaryHeader, secondaryHeader }: ProductListProps) => {
  if (!products?.length) return null;
  const hasImages = products.some(
    (product) => product.image?.image?.url || product.image?.image?.id,
  );
  return (
    <div className="tw-text-neutral-500 tw-flex tw-flex-col tw-gap-y-4 tw-px-4 sm:tw-px-0">
      {title && <h5 className="tra-text-web-sub-2 md:tw-text-xl ">{title}</h5>}
      <ul
        className={classNames(
          'tw-grid sm:tw-grid-cols-3 tw-list-none tw-pl-0',
          appConfig.isTraeger && 'tw-gap-x-6 tw-gap-y-5 sm:tw-gap-y-10',
          appConfig.isMeater && 'tw-gap-[1px]',
          !hasImages && 'tw-grid-cols-2',
        )}
      >
        {products.filter(Boolean).map((product, i) => (
          <li key={i}>
            {appConfig.isTraeger ? (
              <ProductCard
                {...product}
                primaryHeader={primaryHeader}
                secondaryHeader={secondaryHeader}
              />
            ) : (
              <ProductCardMeater
                {...product}
                primaryHeader={primaryHeader}
                secondaryHeader={secondaryHeader}
              />
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductList;
